<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13lfSrs/tc-custom/9780802194510.jpg?1700957997205" alt="This image is the cover for the book Harbor Nocturne"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Harbor Nocturne
      </h1>
      <p class="bookDescription body article font2">
        <b>A “darkly comic, gritty look at life on the streets” from the former LAPD detective and multiple <i>New York Times</i> bestseller (<i>Publishers Weekly</i>).</b><br/>  <br/> In the southernmost Los Angeles district of San Pedro, one of the world’s busiest harbors, an unlikely pair of lovers are unwittingly caught between the two warring sides of the law. When Dinko Babich, a young longshoreman, delivers Lita Medina, a young Mexican dancer, from the harbor to a Hollywood nightclub, theirs lives are forever changed, as their love develops among the myriad cops and criminals who occupy the harbor. Suspense and tragedy are intertwined in the everyday life of the cops and residents of San Pedro Harbor, with the unflinching eye for detail and spot-on humor that only a master of the form like Joseph Wambaugh can provide. Their paths will cross with many colorful characters introduced in Wambaugh’s acclaimed bestselling <i>Hollywood Station</i> series: the surfer cops known as “Flotsam and Jetsam”, aspiring actor “Hollywood Nate” Weiss, young Britney Small, along with new members of the midwatch. Humor, love, suspense and tragedy are intertwined in the everyday life of the cops and residents of San Pedro Harbor, with the unflinching eye for detail and spot-on humor that only a master of the form like Joseph Wambaugh can provide.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Wambaugh
      </h2>
      
      <p class="authorDescription body article">The son of a policeman, Joseph Wambaugh (b. 1937) began his writing career while a member of the Los Angeles Police Department. He joined the LAPD in 1960 after three years in the Marine Corps, and rose to the rank of detective sergeant before retiring in 1974. His first novel, <i>The New Centurions</i> (1971), was a quick success, drawing praise for its realistic action and intelligent characterization, and was adapted into a feature film starring George C. Scott. He followed it up with <i>The Blue Knight</i> (1972), which was adapted into a mini-series starring William Holden and Lee Remick.&#160;Since then Wambaugh has continued writing about the LAPD. He has been credited with a realistic portrayal of police officers, showing them not as superheroes but as men struggling with a difficult job, a depiction taken mainstream by television&rsquo;s <i>Police Story</i>, which Wambaugh helped create in the mid-1970s. In addition to novels, Wambaugh has written nonfiction, winning a special Edgar Award for 1974&rsquo;s <i>The Onion Field</i>, an account of the longest criminal trial in California history. His most recent work is the novel <i>Hollywood Moon</i> (2010). <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      978-0-8021-2610-8
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?326bd78c